const ModalComponent = props => <div className="dashboard-modal">{props.children}</div>

export default ModalComponent
